import { ref, customRef, UnwrapRef } from "vue"

export function usarDebounces() {
  const debounce = <A = unknown>(
    fn: (args: A) => void,
    ms: number
  ): ((args: A) => void) => {
    let timeout: NodeJS.Timeout

    return (args: A): void => {
      if (!timeout) {
        fn(args)
      }

      clearTimeout(timeout)

      timeout = setTimeout((): void => {
        fn(args)
      }, ms)
    }
  }
  const debounceAsync = <A = unknown, R = void>(
    fn: (args: A) => R,
    ms: number
  ): [(args: A) => Promise<R>, () => void] => {
    let timer: NodeJS.Timeout

    const debouncedFunc = (args: A): Promise<R> =>
      new Promise((resolve) => {
        if (timer) {
          clearTimeout(timer)
        }

        timer = setTimeout(() => {
          resolve(fn(args))
        }, ms)
      })

    const destruir = () => clearTimeout(timer)

    return [debouncedFunc, destruir]
  }
  const debouncedToRef = <I = unknown>(
    valorInicial: I,
    tempoDeEspera: number
  ) => {
    const estado = ref<I>(valorInicial)
    return customRef((track, trigger) => ({
      get() {
        track()
        return estado.value
      },
      set: debounce((valor) => {
        estado.value = valor as UnwrapRef<I>
          trigger()
      }, tempoDeEspera),
    }))
  }
  return {
    debounce,
    debouncedToRef,
    debounceAsync,
  }
}
